module.exports = __webpack_public_path__ + "img/hiraya-mnl.5f2c1780.png";